/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Emergency contact information. Required if anything is dangerous.<br/>Shipments that pick up or deliver in Canada should also supply tdgResponsibleName for the TDG declaration on the bill of lading.
 * @export
 * @interface EmergencyContactDetailsDraft
 */
export interface EmergencyContactDetailsDraft {
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactDetailsDraft
     */
    contactName?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactDetailsDraft
     */
    contactPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactDetailsDraft
     */
    contactPhoneNumberExtension?: string;
    /**
     * Transport Canada ERAP (Emergency Response Assistance Plan) reference number, in the form 2-1234 or 2-1234-567. Only the higher-risk dangerous goods need a plan, so most shipments leave this empty.<br/>Send this together with erapPhoneNumber. Sending one without the other is rejected.
     * @type {string}
     * @memberof EmergencyContactDetailsDraft
     */
    erapPlanNumber?: string;
    /**
     * The 24-hour phone number used to activate the ERAP in an emergency. A 10-digit North American number; a leading 1 is accepted and dropped.<br/>Send this together with erapPlanNumber. Sending one without the other is rejected.
     * @type {string}
     * @memberof EmergencyContactDetailsDraft
     */
    erapPhoneNumber?: string;
    /**
     * The person certifying the dangerous goods declaration on the bill of lading, as a first and last name. This is a person, not the shipping business.<br/>Needed for the TDG declaration when any line item is dangerous and the shipment picks up or delivers in Canada; the API accepts requests without it, but the dashboard collects it before booking.
     * @type {string}
     * @memberof EmergencyContactDetailsDraft
     */
    tdgResponsibleName?: string;
}

/**
 * Check if a given object implements the EmergencyContactDetailsDraft interface.
 */
export function instanceOfEmergencyContactDetailsDraft(value: object): value is EmergencyContactDetailsDraft {
    return true;
}

export function EmergencyContactDetailsDraftFromJSON(json: any): EmergencyContactDetailsDraft {
    return EmergencyContactDetailsDraftFromJSONTyped(json, false);
}

export function EmergencyContactDetailsDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyContactDetailsDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'contactName': json['contactName'] == null ? undefined : json['contactName'],
        'contactPhoneNumber': json['contactPhoneNumber'] == null ? undefined : json['contactPhoneNumber'],
        'contactPhoneNumberExtension': json['contactPhoneNumberExtension'] == null ? undefined : json['contactPhoneNumberExtension'],
        'erapPlanNumber': json['erapPlanNumber'] == null ? undefined : json['erapPlanNumber'],
        'erapPhoneNumber': json['erapPhoneNumber'] == null ? undefined : json['erapPhoneNumber'],
        'tdgResponsibleName': json['tdgResponsibleName'] == null ? undefined : json['tdgResponsibleName'],
    };
}

  export function EmergencyContactDetailsDraftToJSON(json: any): EmergencyContactDetailsDraft {
      return EmergencyContactDetailsDraftToJSONTyped(json, false);
  }

  export function EmergencyContactDetailsDraftToJSONTyped(value?: EmergencyContactDetailsDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactName': value['contactName'],
        'contactPhoneNumber': value['contactPhoneNumber'],
        'contactPhoneNumberExtension': value['contactPhoneNumberExtension'],
        'erapPlanNumber': value['erapPlanNumber'],
        'erapPhoneNumber': value['erapPhoneNumber'],
        'tdgResponsibleName': value['tdgResponsibleName'],
    };
}

